// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2qlx5","gfeWrapper":"CalendarEvent_gfeWrapper__1MpfZ"};